import React,{useState} from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png"
import icon1 from "../../assets/images/icon1.png"
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import icrageeLogo from "../../assets/images/icragee.png"
import ImportantDates from "../../components/ImportantDates/ImportantDates";
import Footer from "../../components/Footer/Footer";
import venueImage from "../../assets/images/venue.png"
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg"
import mapImage from "../../assets/images/map.png"
import Navbar from "../../components/Navbar/Navbar"
import Layout from "../../components/Layout/layout";

const ComingSoon = () => {
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    const handleMouseEnter = () => {
        setDropdownVisible(true);
    };

    const handleMouseLeave = () => {
        setDropdownVisible(false);
    };
    const [isDropdownVisible2, setDropdownVisible2] = useState(false);

    const handleMouseEnter2 = () => {
        setDropdownVisible2(true);
    };

    const handleMouseLeave2 = () => {
        setDropdownVisible2(false);
    };
    return(
        <Layout>
        <main className="bg-gray-100">
        <div className="flex absolute md:mt-[-10vw] mt-[-10vw] md:flex-row flex-col items-center w-full justify-center gap-12">
            <div className="text-[55px] text-white"
                style={{ fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000' }}
            >
                COMING SOON
            </div>
        </div>
    </main>
    </Layout>
    );
}
export default ComingSoon;